import { render } from "./SelectTag.vue?vue&type=template&id=7033df7d&scoped=true"
import script from "./SelectTag.vue?vue&type=script&lang=js"
export * from "./SelectTag.vue?vue&type=script&lang=js"

import "./SelectTag.vue?vue&type=style&index=0&id=7033df7d&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7033df7d"]])

export default __exports__